import React from 'react';
import { useScore } from '../context/ScoreContext';
import { Link } from 'react-router-dom';

const Scoreboard = ({ isDarkMode }) => {
  const { scores, resetScores } = useScore();
  
  const games = [
    { id: 'puzzle', name: 'Jigsaw Puzzle', icon: '🧩' },
    { id: 'memory', name: 'Memory Game', icon: '🎯' },
    { id: 'code-quiz', name: 'Code Quiz', icon: '💻' },
    { id: 'typing', name: 'Typing Speed', icon: '⌨️' },
    { id: 'binary', name: 'Binary Converter', icon: '🔢' },
    { id: 'logic', name: 'Logic Puzzle', icon: '🧠' },
    { id: 'dragdrop', name: 'React Layout', icon: '📐' },
    { id: 'bug', name: 'Bug Hunter', icon: '🐛' },
    { id: 'keyboard', name: 'Keyboard Shortcuts', icon: '⌨️' },
    { id: 'code-runner', name: 'Code Runner', icon: '⚡' }
  ];

  const totalScore = Object.values(scores).reduce((a, b) => a + b, 0);
  const gameCount = Object.keys(scores).length;

  const pageStyle = {
    minHeight: '100vh',
    backgroundColor: isDarkMode ? '#0a0a1a' : '#f5f5f5',
    padding: '20px'
  };

  const containerStyle = {
    maxWidth: '600px',
    margin: '0 auto'
  };

  const cardStyle = {
    background: isDarkMode ? '#1a1a2e' : '#fff',
    borderRadius: '15px',
    padding: '20px',
    marginBottom: '20px',
    boxShadow: isDarkMode ? '0 4px 20px rgba(0,0,0,0.5)' : '0 4px 20px rgba(0,0,0,0.1)'
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <Link to="/" style={{
          display: 'inline-block',
          padding: '10px 25px',
          marginBottom: '20px',
          background: isDarkMode ? '#333' : '#e0e0e0',
          color: isDarkMode ? '#fff' : '#000',
          textDecoration: 'none',
          borderRadius: '8px'
        }}>
          ← მთავარი
        </Link>

        <h1 style={{ 
          color: isDarkMode ? '#fff' : '#000', 
          textAlign: 'center',
          fontSize: '2rem'
        }}>
          🏆 ჩემი ქულები
        </h1>

        {/* სულ ქულა */}
        <div style={cardStyle}>
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '3rem', fontWeight: 'bold', color: '#667eea' }}>
              {totalScore}
            </div>
            <div style={{ color: isDarkMode ? '#aaa' : '#666' }}>
              ⭐ სულ ქულა ({gameCount}/{games.length} თამაში)
            </div>
          </div>
        </div>

        {/* თითოეული თამაში */}
        {games.map(game => {
          const score = scores[game.id] || 0;
          const isPlayed = score > 0;
          
          return (
            <div key={game.id} style={{
              ...cardStyle,
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              opacity: isPlayed ? 1 : 0.5
            }}>
              <div>
                <span style={{ fontSize: '24px', marginRight: '10px' }}>{game.icon}</span>
                <span style={{ color: isDarkMode ? '#fff' : '#000' }}>
                  {game.name}
                </span>
              </div>
              <div style={{ 
                fontSize: '20px', 
                fontWeight: 'bold',
                color: isPlayed ? '#4ade80' : (isDarkMode ? '#555' : '#ccc')
              }}>
                {score}
              </div>
            </div>
          );
        })}

        {/* ღილაკები */}
        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <Link to="/games" style={{
            flex: 1,
            padding: '12px',
            background: '#667eea',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            textAlign: 'center',
            textDecoration: 'none',
            fontWeight: 'bold'
          }}>
            🎮 ითამაშე
          </Link>
          <button onClick={resetScores} style={{
            flex: 1,
            padding: '12px',
            background: isDarkMode ? '#333' : '#e0e0e0',
            color: isDarkMode ? '#fff' : '#000',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}>
            🗑️ ქულების გასუფთავება
          </button>
        </div>
      </div>
    </div>
  );
};

export default Scoreboard;